import React, { useContext, useEffect } from 'react';
import { Switch, Route } from "react-router-dom";
import EvaluationContext from '../../context/evaluation/evaluationContext';
import Navbar from "../../layout/Navbar";
import Introduccion from '../../components/mentoring/Introduccion';
import Evaluacion from '../../components/mentoring/Evaluacion';
import Mentor from "../register/Mentor";
import Alumno from "../register/Alumno";
import MatchFromStudent from './MatchFromStudent';
import MatchFromTeacher from './MatchFromTeacher';

function Dashboard() {

    const evaluationContext = useContext(EvaluationContext);
    const { obtenerFormularios } = evaluationContext;

    useEffect(() => {
        obtenerFormularios()
        // eslint-disable-next-line
    }, [])

    return (
        <>
            <Navbar />

            <Switch>
                <Route exact path="/mentorias" component={Introduccion} />
                <Route exact path="/evaluacion" component={Evaluacion} />
                <Route exact path="/alumnosAsignados" component={MatchFromTeacher} />
                <Route exact path="/mentorAsignado" component={MatchFromStudent} />
                <Route exact path="/editTeacher" component={Mentor} />
                <Route exact path="/editStudent" component={Alumno} />
            </Switch>
        </>
    )
}

export default Dashboard